import { Controller, UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'next-i18next';
import { StoreImageType } from '../../../../consts';
import { StoreAssetUploadDataType, UploadCommonFormProps } from '../../../../types/StoreTypes';
import S from './UploadCommonForm.module.scss';
import UploadImagesGrid from './UploadImagesGrid';

/**
 * 맵/오베젝트 공통 정보 입력 폼
 * @param props
 * @constructor
 */
const UploadCommonObjectForm = (props: UploadCommonFormProps) => {
  const {
    isEditBlocked,
    commonForm
  } = props;
  const {
    t
  } = useTranslation(['store']);
  const {
    control,
    formState: {
      errors
    }
  } = commonForm as UseFormReturn<StoreAssetUploadDataType>;
  return <div className={S.upload_form} data-sentry-component="UploadCommonObjectForm" data-sentry-source-file="UploadCommonObjectForm.tsx">
      <div className={S.upload_form_row}>
        <label>
          {t('store:store_upload_something', {
          x: t('store:store_asset_object_set')
        })}
        </label>
        <Controller control={control} name="objectImageKeyList" render={({
        field: {
          value,
          onChange
        }
      }) => <UploadImagesGrid gridKey={'object'} assetImageKeyList={value ?? []} onFilesAdd={imageKeys => onChange([...(value ?? []), ...imageKeys])} onFileRemove={index => {
        value && value?.splice(index, 1);
        onChange(value);
      }} imageType={StoreImageType.object} disabled={isEditBlocked} fileMaxCount={100} aspectRatio="1/1" />} data-sentry-element="Controller" data-sentry-source-file="UploadCommonObjectForm.tsx" />
        {!!errors.objectImageKeyList && <div className={S.error_text}>
            {errors.objectImageKeyList?.message}
          </div>}
      </div>
    </div>;
};
export default UploadCommonObjectForm;